module.exports = __webpack_public_path__ + "static/media/Leyland-logo-640x550.c1308195.jpg";